import React from 'react'

import { GoDotFill } from "react-icons/go";
import { FaRegCalendarAlt } from "react-icons/fa";
import { TbRotate2 } from "react-icons/tb";
import { FaEye } from "react-icons/fa";
import { FaRegCircle } from "react-icons/fa";


const AnnounceBody = () => {
  return (
    <div className='pt-36 pl-96 px-20 w-full flex items-start h-screen gap-10 max-sm:gap-0 max-sm:px-4 max-sm:w-screen max-sm:pt-24 max-sm:h-full max-sm:block'>
        <div className='bg-white p-10 px-20 rounded-3xl  max-sm:px-3 max-sm:mb-10'>
            <p className='flex items-center gap-4 text-xl font-semibold max-sm:text-sm max-sm:gap-2 max-sm:pb-5'><GoDotFill className='text-blue-800'/> Announcements</p>
            <div className=' h-200 overflow-y-scroll px-10 max-sm:px-5 '>

                <div className='py-5'>
                    <p className='flex gap-4 items-center font-semibold'><FaRegCalendarAlt className='text-blue-800'/>Event</p>
                    <p className='text-sm py-5 text-zinc-500 max-sm:text-xs max-sm:text-justify' >
                        Algorand has set an event for fresh & upcoming devs to participate in the building of a new tech solution, <br />
                        happenning live in Nigeria,Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
                    </p>
                    <div className='flex items-center max-sm:block'>
                        <p className='text-sm text-blue-800 font-semibold'>View Event</p>

                        <div className='flex gap-5 items-center ml-auto max-sm:block max-sm:pt-4'>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><TbRotate2 /> Posted 2mins ago</p>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><FaEye /> 168 Views</p>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><FaRegCalendarAlt /> 58 Scheduled</p>
                        </div>
                    </div>
                </div>

                <hr />


                <div className='py-5'>
                    <p className='flex gap-4 items-center font-semibold'><FaRegCalendarAlt className='text-blue-800'/>Event</p>
                    <p className='text-sm py-5 text-zinc-500 max-sm:text-xs max-sm:text-justify' >
                        Algorand has set an event for fresh & upcoming devs to participate in the building of a new tech solution, <br />
                        happenning live in Nigeria,Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
                    </p>
                    <div className='flex items-center max-sm:block'>
                        <p className='text-sm text-blue-800 font-semibold'>View Event</p>

                        <div className='flex gap-5 items-center ml-auto max-sm:block max-sm:pt-4'>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><TbRotate2 /> Posted 2mins ago</p>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><FaEye /> 168 Views</p>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><FaRegCalendarAlt /> 58 Scheduled</p>
                        </div>
                    </div>
                </div>


                <hr />

                <div className='py-5'>
                    <p className='flex gap-4 items-center font-semibold'><FaRegCalendarAlt className='text-blue-800'/>Event</p>
                    <p className='text-sm py-5 text-zinc-500 max-sm:text-xs max-sm:text-justify' >
                        Algorand has set an event for fresh & upcoming devs to participate in the building of a new tech solution, <br />
                        happenning live in Nigeria,Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
                    </p>
                    <div className='flex items-center max-sm:block'>
                        <p className='text-sm text-blue-800 font-semibold'>View Event</p>

                        <div className='flex gap-5 items-center ml-auto max-sm:block max-sm:pt-4'>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><TbRotate2 /> Posted 2mins ago</p>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><FaEye /> 168 Views</p>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><FaRegCalendarAlt /> 58 Scheduled</p>
                        </div>
                    </div>
                </div>


                <hr />


                <div className='py-5'>
                    <p className='flex gap-4 items-center font-semibold'><FaRegCalendarAlt className='text-blue-800'/>Event</p>
                    <p className='text-sm py-5 text-zinc-500 max-sm:text-xs max-sm:text-justify' >
                        Algorand has set an event for fresh & upcoming devs to participate in the building of a new tech solution, <br />
                        happenning live in Nigeria,Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy
                    </p>
                    <div className='flex items-center max-sm:block'>
                        <p className='text-sm text-blue-800 font-semibold'>View Event</p>

                        <div className='flex gap-5 items-center ml-auto max-sm:block max-sm:pt-4'>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><TbRotate2 /> Posted 2mins ago</p>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><FaEye /> 168 Views</p>
                            <p className='text-xs text-zinc-500 flex items-center gap-2 max-sm:py-1'><FaRegCalendarAlt /> 58 Scheduled</p>
                        </div>
                    </div>
                </div>

                <hr />

            </div>            
        </div>

        <div className=' bg-white w-100 ml-auto p-10 rounded-3xl max-sm:px-5 max-sm:w-full'>

            <p className='flex items-center gap-4 text-xl font-semibold max-sm:text-sm'><GoDotFill className='text-blue-800 '/> Notification</p>
            
            <div className='h-200 overflow-y-scroll px-5'>
                <div>
                    <p className='text-sm text-zinc-400 pt-5 max-sm:text-xs'>This Week</p>
                    <div className='flex items-start gap-4 py-5'>
                        <FaRegCircle className='text-blue-800'/>
                        <div>
                            <p className='text-sm text-zinc-500 max-sm:text-xs'>Donation  algoname has donated $50 to the algo meet up event</p>
                            <p className='text-xs text-zinc-300 pt-2'>01 jan 2023</p>
                        </div>
                    </div>

                    <hr />

                    <div className='flex items-start gap-4 py-5'>
                        <FaRegCircle className='text-blue-800'/>
                        <div>
                            <p className='text-sm text-zinc-500 max-sm:text-xs'>Donation  algoname has donated $50 to the algo meet up event</p>
                            <p className='text-xs text-zinc-300 pt-2'>01 jan 2023</p>
                        </div>
                    </div>

                    <hr />
                </div>

                <div>
                    <p className='text-sm text-zinc-400 pt-5 max-sm:text-xs'>Last Week</p>
                    <div className='flex items-start gap-4 py-5'>
                        <FaRegCircle className='text-blue-800'/>
                        <div>
                            <p className='text-sm text-zinc-500 max-sm:text-xs'>Donation  algoname has donated $50 to the algo meet up event</p>
                            <p className='text-xs text-zinc-300 pt-2'>01 jan 2023</p>
                        </div>
                    </div>

                    <hr />

                    <div className='flex items-start gap-4 py-5'>
                        <FaRegCircle className='text-blue-800'/>
                        <div>
                            <p className='text-sm text-zinc-500 max-sm:text-xs'>Donation  algoname has donated $50 to the algo meet up event</p>
                            <p className='text-xs text-zinc-300 pt-2'>01 jan 2023</p>
                        </div>
                    </div>

                    <hr />
                </div>
                
                <div>
                    <p className='text-sm text-zinc-400 pt-5 max-sm:text-xs'>Last Month</p>
                    <div className='flex items-start gap-4 py-5'>
                        <FaRegCircle className='text-blue-800'/>
                        <div>
                            <p className='text-sm text-zinc-500 max-sm:text-xs'>Donation  algoname has donated $50 to the algo meet up event</p>
                            <p className='text-xs text-zinc-300 pt-2'>01 jan 2023</p>
                        </div>
                    </div>

                    <hr />

                    <div className='flex items-start gap-4 py-5'>
                        <FaRegCircle className='text-blue-800'/>
                        <div>
                            <p className='text-sm text-zinc-500 max-sm:text-xs'>Donation  algoname has donated $50 to the algo meet up event</p>
                            <p className='text-xs text-zinc-300 pt-2'>01 jan 2023</p>
                        </div>
                    </div>

                    <hr />
                </div>
            </div>
        </div>
    </div>
  )
}

export default AnnounceBody